import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-senior-ranking',
    templateUrl: './senior-ranking.component.html',
    styleUrls: ['./senior-ranking.component.scss'],
})
export class SeniorRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Senior
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_SENIOR;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_SENIOR;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
